import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api/agreements';

export const fetchAgreements = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Gagal memuat data agreement:', error);
        throw error;
    }
};